import { Action, ScenarioPlanName } from '../api/gql';

export const actionToTransMap: Record<Action, string> = {
  [Action.Call]: 'task.call',
  [Action.Email]: 'task.email',
  [Action.Sms]: 'task.sms',
};

export const scenarioPlanToTransMap: Record<ScenarioPlanName, string> = {
  [ScenarioPlanName.Plan_321]: 'plan.321',
  [ScenarioPlanName.Plan_331]: 'plan.331',
  [ScenarioPlanName.Plan_551]: 'plan.551',
};
